import { createFileRoute } from "@tanstack/react-router";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PageHeader } from "@/components/layout/page";
import { Breadcrumbs } from "@/components/nav/breadcrumbs";
import { CodeBlock } from "@/components/display/code-block";
import { LoadingState, ErrorState } from "@/components/feedback/states";
import { API_BASE } from "@/lib/http";
import { useQueryEndpoint } from "@/api/endpoints";

export const Route = createFileRoute("/_app/endpoints/query/$id")({
  component: QueryDetail,
});

function QueryDetail() {
  const { id } = Route.useParams();
  const { data: e, isLoading, error, refetch } = useQueryEndpoint(id);

  if (isLoading) return <LoadingState />;
  if (error || !e) return <ErrorState error={error ?? "Not found"} onRetry={() => refetch()} />;

  const base = API_BASE.replace(/\/api$/, "");
  const curl = `curl "${base}/api/v1/external/query/${e.slug}?page=1&size=${e.defaultPageSize ?? 100}" \\
  -H "X-API-Key: udip_..."`;

  return (
    <Stack spacing={3}>
      <PageHeader
        title={e.name}
        breadcrumbs={
          <Breadcrumbs
            items={[
              { label: "Endpoints", to: "/endpoints" },
              { label: "Query", to: "/endpoints/query" },
              { label: e.name },
            ]}
          />
        }
        description={e.description ?? undefined}
      />
      {e.sqlOverride ? (
        <Card sx={{ p: 2 }}>
          <Typography variant="h4" sx={{ mb: 1 }}>
            SQL
          </Typography>
          <CodeBlock code={e.sqlOverride} language="sql" />
        </Card>
      ) : null}
      <Card sx={{ p: 2 }}>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Fetch
        </Typography>
        <CodeBlock code={curl} language="bash" />
      </Card>
    </Stack>
  );
}
